import { DateRangeParameterDTO, GetParkingSessionIdsForParkerDTO, ParkerRegistrationClient } from '../../../../../base/models/models.swagger.generated';
import { Observable, catchError, forkJoin, map, of, switchMap, tap } from "rxjs";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { ParkerDTO, ParkingClient } from "src/app/base/models/models.swagger.generated";
import { DateTime } from "luxon";
import { ParkerInfo } from '../parker-execution-status';
import { FromUntilFormGroup } from '../parker-function-from-until-form/parker-function-from-until-form.types';

export class RecalculateParkingSessionsExecutor extends ParkerFunctionExecutor {
  private from: DateTime;
  private until: DateTime;

  constructor(numTotalRecordsToWorkOn: number,
    private fromUntilForm: FromUntilFormGroup,
    private parkingClient: ParkingClient,
    private parkerRegistrationClient: ParkerRegistrationClient) {
    super(numTotalRecordsToWorkOn);
  }

  protected prepare(): Observable<void> {
    const today = DateTime.now().startOf('day');
    this.from = this.fromUntilForm.value.from ? DateTime.fromJSDate(this.fromUntilForm.value.from) : today;
    this.until = this.fromUntilForm.value.until ? DateTime.fromJSDate(this.fromUntilForm.value.until) : today;
    return of(null); // nothing more to prepare
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
    return this.recalculateSessions(parker);
  }

  public recalculateSessions(parker: ParkerDTO): Observable<number> {
    const dto = new GetParkingSessionIdsForParkerDTO({
      clientId: parker.clientId,
      parkerId: parker.id,
      dateRange: new DateRangeParameterDTO({startDate: this.from?.toISO(), endDate: this.until?.toISO()})
    });

    return this.parkingClient.getParkingSessionIdsForParker(dto).pipe(
      switchMap((sessionInfos) => {
        const parkerInfo = new ParkerInfo(parker);
        if (sessionInfos.length > 0) {
          return forkJoin([...sessionInfos.map(sessionInfo => this.parkerRegistrationClient.recalculateParkingSession(sessionInfo.id, undefined)
            .pipe(
              tap(() => {
                this.progressInfo.incrementIteration();
              }),
              catchError(error => {
                this.progressInfo.incrementIteration();
                this.executionStatus.push({
                  status: 'error',
                  message: error.message,
                  parkerInfo
                });
                return of(null);
              })
            ))]).pipe(map(() => parker));
        }
        return of(parker);
      }),
      map(parker => parker.id)
    );
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    return parkers;
  }
}
